// extracted by mini-css-extract-plugin
export default {"container":"viewPart_container__NJ1Ss","content":"viewPart_content__1LPwb"};